import create from 'zustand'

const initialForm = {
  name: null,
  address: null,
  province_id: null,
  city_id: null,
  subdistrict_id: null,
  postal_code: null,
  phone: null,
  rajaOngkirId: null,
  provinceName: null,
  cityName: null,
  districtName: null,
  subdistrictName: null,
  type: 'pribadi',
}

export const useAddAddressStore = create(set => ({
  open: false,
  form: { ...initialForm },
  zIndex: null,
  onCloseComplete: null,

  openModal: zIndex => {
    set({
      open: true,
      zIndex,
    })
  },

  closeModal: () => {
    set(() => ({
      open: false,
      form: { ...initialForm },
    }))
  },

  setOnCloseComplete: fn => {
    if (typeof fn === 'function') {
      set({ onCloseComplete: fn })
    }
  },

  clearOnCloseComplete: () => set({ onCloseComplete: null }),

  setForm: updater =>
    set(state => ({
      form: typeof updater === 'function' ? updater(state.form) : updater,
    })),
}))
